var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};


Curriculog.ProposalForm.FieldModels = (function ($, _, Backbone, FieldModels) {

    FieldModels = Curriculog.CurriculogCollection.extend({
        // model: Curriculog.ProposalForm.FieldModel,
        model: function(attrs, options) {
            var type = attrs.type;
            var models = {
                text: Curriculog.ProposalForm.FieldModel,
                textarea: Curriculog.ProposalForm.FieldModel,
                richtext: Curriculog.ProposalForm.RichTextModel,
                checkbox: Curriculog.ProposalForm.FieldModel,
                radio: Curriculog.ProposalForm.FieldModel,
                smartfield: Curriculog.ProposalForm.SmartFieldModel
                // curriculum: Curriculog.ProposalForm.FieldModel,
                // assessment: Curriculog.ProposalForm.FieldModel
            };
            if (!(type in models)) {
                throw Error('Unknown model type: ' + type);
            }
            return new models[type](attrs, options);
        }

    });

    return FieldModels;

})($, _, Backbone, Curriculog.ProposalForm.FieldModels || {});

